import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText, Shield, Clock } from 'lucide-react';
import axios from 'axios';

const API = `${window.location.origin}/api`;

export default function LegalPage({ type }) {
  const [content, setContent] = useState('');
  const [lastUpdated, setLastUpdated] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const isTerms = type === 'terms';
  const title = isTerms ? 'Terms and Conditions' : 'Privacy Policy';
  const Icon = isTerms ? FileText : Shield;

  useEffect(() => {
    axios.get(`${API}/cms/legal/${type}`)
      .then(res => {
        setContent(res.data?.content || '');
        setLastUpdated(res.data?.last_updated || '');
      })
      .catch(() => setContent('<p>Content not available.</p>'))
      .finally(() => setLoading(false));
  }, [type]);

  const sanitizeHtml = (html) => html ? html.replace(/&nbsp;/g, ' ') : '';
  
  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    } catch {
      return dateStr;
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-slate-900 text-white py-6">
        <div className="max-w-3xl mx-auto px-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-slate-300 hover:text-white mb-4 text-sm"
            data-testid="legal-back-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
          <div className="flex items-center gap-3">
            <Icon className="w-6 h-6 text-amber-500" />
            <h1 className="text-2xl font-bold" data-testid="legal-page-title">{title}</h1>
          </div>
          {lastUpdated && (
            <div className="flex items-center gap-2 mt-2 text-slate-400 text-sm" data-testid="legal-last-updated">
              <Clock className="w-4 h-4" />
              <span>Last updated: {formatDate(lastUpdated)}</span>
            </div>
          )}
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 py-8">
        {loading ? (
          <div className="flex justify-center py-12">
            <div className="w-8 h-8 border-4 border-amber-500 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <div
            className="wysiwyg-content prose prose-sm max-w-none prose-headings:text-slate-900 prose-p:text-slate-600 bg-white rounded-xl p-6 sm:p-8 shadow-sm"
            style={{ overflowWrap: 'break-word', wordBreak: 'break-word' }}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
            data-testid="legal-page-content"
          />
        )}
      </div>
    </div>
  );
}
